import { User, UserType } from "types/users";

export enum PermissionDisagreements {
  Customer = "customer",
  Manager = "manager",
  Labeler = "labeler",
}
export const colorClassNameMap: Record<string, string> = {
  PASS: "#5E17E6",
  YES: "#5E17E6",
  FAIL: "#CA00EB",
  NO: "#CA00EB",
  UNSURE: "#535353",
  UNCLEAR: "#535353",
};

export const stringClassNameMap: Record<string, string> = {
  PASS: "YES",
  FAIL: "NO",
  UNSURE: "UNCLEAR",
  __UNSURE: "UNCLEAR",
};

export const isUserCustomer = (customerType: string) =>
  customerType === UserType.Customer ||
  customerType === UserType.CustomerVIP ||
  customerType === UserType.Customer_Internal;

export const getUserPermissionDisagreement = (userData: User | undefined) => {
  if (userData && userData?.userprofile?.customer_type) {
    if (isUserCustomer(userData.userprofile.customer_type)) {
      return PermissionDisagreements.Customer;
    }

    if (userData.userprofile?.customer_type === UserType.Manager) {
      return PermissionDisagreements.Manager;
    }

    return PermissionDisagreements.Labeler;
  }

  return PermissionDisagreements.Labeler;
};
